import { CashReportUserLongTaskInputData } from "@/model/data/userLongTasks/CashReportUserLongTaskInputData";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";

const ENDPOINT = "/user_long_task/cash_report";

export class CreateCashReportLongTaskCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: CashReportUserLongTaskInputData;

    constructor(payload: CashReportUserLongTaskInputData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand({ ...this.payload });
        return new ServiceResponseData(res);
    }
}
